import { Alert, AlertTitle } from '@mui/material'
import React from 'react'

import { UAlertProps } from './type'

export const UAlert = ({
  severity,
  className,
  children,
  title,
}: UAlertProps) => {
  return (
    <Alert severity={severity} className={className}>
      {title && <AlertTitle className="font-weight-bold">{title}</AlertTitle>}
      {children}
    </Alert>
  )
}
